<template>
<div>
    <Breadcrumbs main="HR" submain="Payroll" title="Disbursement Details" />

<b-row v-if="details">

    <b-col md="8">

        <b-card class="custom-card page-section">
            <template #header>
                Disbursement Information
            </template>

            <b-row>
                <b-col md="6" class="mb-3">
                    <div class="info-label">Title</div>
                    <div class="info-value">
                        {{ details.title || 'N/A' }}
                    </div>
                </b-col>

                <b-col md="6" class="mb-3">
                    <div class="info-label">Status</div>

                    <b-badge
                        class="status-badge"
                        :variant="{
                            DRAFT: 'secondary',
                            APPROVED: 'success',
                            DISBURSED: 'primary'
                        }[details.status] || 'warning'"
                    >
                        {{ details.status }}
                    </b-badge>
                </b-col>

                <b-col md="6" class="mb-3">
                    <div class="info-label">Total Entries</div>
                    <div class="info-value">
                        {{ details.total_entries }}
                    </div>
                </b-col>

                <b-col md="6" class="mb-3">
                    <div class="info-label">Total Amount</div>
                    <div class="info-value">
                        ৳ {{ Number(details.total_pay_amount || 0).toLocaleString() }}
                    </div>
                </b-col>

                <b-col md="12">
                    <div class="info-label">Notes</div>
                    <div class="info-value">
                        {{ details.notes || '-' }}
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <b-card class="custom-card">
            <template #header>
                Payroll Sheet Information
            </template>

            <b-row>
                <b-col md="4">
                    <div class="info-label">Month</div>
                    <div class="info-value">
                        {{ details.payroll_sheet?.month }}
                    </div>
                </b-col>

                <b-col md="4">
                    <div class="info-label">Year</div>
                    <div class="info-value">
                        {{ details.payroll_sheet?.year }}
                    </div>
                </b-col>

                <b-col md="4">
                    <div class="info-label">Status</div>
                    <div class="info-value">
                        {{ details.payroll_sheet?.status }}
                    </div>
                </b-col>
            </b-row>
        </b-card>

    </b-col>

    <b-col md="4">
        
        <b-card class="custom-card creator-card">
            <template #header>
               Created By
            </template>

            <div class="text-center">

                <img
                    v-if="details.created_by?.additional_info?.photo"
                    :src="host + details.created_by.additional_info.photo"
                    class="profile-img mb-3"
                >

                <h5 class="mb-1">
                    {{ details.created_by?.full_name }}
                </h5>

                <p class="text-muted mb-3">
                    {{ details.created_by?.email }}
                </p>

                <hr>

                <div class="mb-2">
                    <div class="info-label">Employee ID</div>
                    <div class="info-value">
                        {{ details.created_by?.additional_info?.employee_id }}
                    </div>
                </div>

                <div class="mb-2">
                    <div class="info-label">Department</div>
                    <div class="info-value">
                        {{ details.created_by?.additional_info?.department?.name }}
                    </div>
                </div>

                <div class="mb-2">
                    <div class="info-label">Designation</div>
                    <div class="info-value">
                        {{ details.created_by?.additional_info?.designation?.title }}
                    </div>
                </div>

                <div>
                    <div class="info-label">Phone</div>
                    <div class="info-value">
                        {{ details.created_by?.additional_info?.phone_number }}
                    </div>
                </div>

            </div>

        </b-card>

    </b-col>

</b-row>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { myHost } from '../../../../_helpers/host';

export default {
    data() {
        return {
            host: myHost.host,
        };
    },

    computed: {
        ...mapState({
            details: state => state.payroll.disbursement_detail,
            loading: state => state.payroll.submitLoading,
            error: state => state.payroll.submitError,

        }),
        
    },
    created() {
       
    },
    mounted() {
        this.$store.dispatch("payroll/fetchDisbursementDetail", this.$route.params.id)
    },

    watch: {
        details(oldValue, newValue) {
         
        },

       
    },

    methods: {
       
    }
}
</script>

<style scoped>
<style scoped>
.info-label {
    font-size: 13px;
    color: #6c757d;
    font-weight: 600;
    margin-bottom: 2px;
}

.info-value {
    font-size: 15px;
    font-weight: 500;
    color: #2b2b2b;
}

.profile-img {
    width: 90px;
    height: 90px;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid #f8f9fa;
    box-shadow: 0 2px 8px rgba(0,0,0,.1);
}

.custom-card {
    border: 0;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,.06);
    overflow: hidden;
}

.custom-card .card-header {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    font-weight: 600;
    padding: 1rem 1.25rem;
}

.status-badge {
    font-size: 12px;
    padding: 6px 10px;
}

.page-section {
    margin-bottom: 20px;
}

.creator-card {
    position: sticky;
    top: 20px;
}
</style>
</style>
